import { build } from './build-info';
import { AppEnvironment } from './environment.type';
import { getGatewayUrls } from './gateway.utils';

const gatewayUrls = getGatewayUrls('sandbox');

export const environment: AppEnvironment = {
    build,
    BUILD_VERSION: build.branch,
    STAGE: 'sandbox',
    origins: {
        ACCOUNT_ACCESS_URL: 'https://sandbox-api.bannerflow.com/account-access',
        AD_SERVICE_URL: 'https://c.sandbox-bannerflow.net',
        ANALYTICS_BACKEND_SERVICE_URL: 'https://sandbox-api.bannerflow.com/ab',
        ANALYTICS_REPORT_SCHEDULER_SERVICE_URL: 'https://sandbox-api.bannerflow.com/ars',
        API_GATEWAY_URL: 'https://sandbox-api.bannerflow.com',
        APP_URL: gatewayUrls.APP_URL,
        B2_URL: 'https://sandbox-b2.bannerflow.com',
        BFC_URL: gatewayUrls.BFC_URL,
        CAMPAIGN_MANAGER_URL: 'https://sandbox-cm.bannerflow.com',
        CAMPAIGN_SERVICE_URL: 'https://sandbox-api.bannerflow.com/cs',
        LIST_SERVICE_URL: 'https://sandbox-api.bannerflow.com/list-service',
        MIGRATION_SERVICE_URL: 'https://sandbox-migrationservice.bannerflow.com',
        NOTIFICATION_SERVICE_URL: 'https://sandbox-api.bannerflow.com/notification-service/api',
        PUBLISH_SERVICE_URL: 'https://sandbox-api.bannerflow.com/ps',
        SCHEDULE_MIGRATION_CLIENT_URL: 'https://sandbox-smc.bannerflow.com',
        SOCIAL_ACCOUNT_SERVICE_URL: 'https://sandbox-sas.bannerflow.net',
        SOCIAL_CAMPAIGN_MANAGER_URL: 'https://sandbox-scm.bannerflow.com',
        SOCIAL_CAMPAIGN_SERVICE_URL: 'https://sandbox-scs.bannerflow.com',
        STUDIO_URL: gatewayUrls.STUDIO_URL
    },
    GTM_ID: 'GTM-M2FZ5ZZ',
    INTERCOM_ID: 'vc7jxmzv',
    CLIENT_ID: 'UWsnkgbv8vdzN3xKWmhaiWjCcVhE0x9H',
    LOGIN_URL: 'https://sandbox-login.bannerflow.com',
    FEATURE_FLAG: {
        enabled: true,
        clientKey: '*:development.26a12aa0d2ddd20c7e5519a984532c29a2c85c06aed6a279c28ee3c2'
    },
    NSSignalR: {
        enabled: true,
        url: 'https://sandbox-api.bannerflow.com/notification-service/hub'
    }
};
